import { Injectable } from '@angular/core';
import { Bairro, Cidade } from '@tivic-team/manager-ts/dist/grl';
import { CidadeController } from 'app/controllers/grl/cidade.controller';
import { CidadeDTO } from 'app/dtos/grl/cidade.dto';
import { CidadeSearch } from 'app/services/grl/cidade.search';
import { LoaderService } from '../loader.service';

@Injectable()
export class CidadeService{

    constructor(
        private _cidadeController:CidadeController,
        private _loaderService:LoaderService,
    ){}

    async find(cidadeSearch?:CidadeSearch):Promise<Cidade[]>{
        try{return await this._cidadeController.find(cidadeSearch && cidadeSearch.getFilters() || null);}
        catch(error){return [];}
    }

    async get(cdCidade:number):Promise<CidadeDTO>{
        this._loaderService.show();
        return this._cidadeController.get(cdCidade).finally(() => this._loaderService.hide());
    }

    async save(cidade: Cidade): Promise<Cidade> {
        this._loaderService.show();
        if(cidade.cdCidade && cidade.cdCidade > 0){
            return this._cidadeController.update(cidade).finally(() => this._loaderService.hide());
        } else {
            return this._cidadeController.create(cidade).finally(() => this._loaderService.hide());
        }
    }

    async getBairros(cdCidade:number):Promise<Bairro[]>{
        this._loaderService.show();
        return this._cidadeController.getBairros(cdCidade).finally(() => this._loaderService.hide());
    }
    
}